export const freightMocks = {
  oceanFred: [
    {
      id: '1',
      departurePort: 'Kanazawa, Japan',
      destinationPort: 'Russia',
      twentyFt: 1400000,
      fortyFt: 2500000,
      estimatedDate: '2021/10/18',
    },
    {
      id: '2',
      departurePort: 'Osaka, Japan',
      destinationPort: 'Nigeria',
      twentyFt: 1400000,
      fortyFt: 2500000,
      estimatedDate: '2021/10/18',
    },
    {
      id: '3',
      departurePort: 'Russia',
      destinationPort: 'Russia',
      twentyFt: 1400000,
      fortyFt: 2500000,
      estimatedDate: '2021/10/18',
    },
    {
      id: '4',
      departurePort: 'Russia',
      destinationPort: 'Russia',
      twentyFt: 1400000,
      fortyFt: 2500000,
      estimatedDate: '2021/10/18',
    },
  ],
  inlandCharge: [
    {
      id: '5',
      departurePort: 'Russia',
      destinationPort: 'Russia',
      twentyFt: 60000,
      fortyFt: 80000,
    },
    {
      id: '6',
      departurePort: 'Nigeria',
      destinationPort: 'Nigeria',
      twentyFt: 60000,
      fortyFt: 80000,
    },
    {
      id: '7',
      departurePort: 'Russia',
      destinationPort: 'Russia',
      twentyFt: 60000,
      fortyFt: 80000,
    },
    {
      id: '8',
      departurePort: 'Russia',
      destinationPort: 'Russia',
      twentyFt: 60000,
      fortyFt: 80000,
    },
  ],
}
